(function () {
    "use strict";

    angular
        .module("app")
        .directive("freightGroupSearchHelp", ["SearchFactory", freightGroupSearchHelp]);

    function freightGroupSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.freightGroupKey = "";
                        scope.freightGroupName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.freightGroupKey === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.freightGroupSearch(scope.sapBrandId, function (freightGroup) {
                        scope.freightGroupKey = freightGroup ? freightGroup.FreightGroupKey : "";
                        scope.freightGroupName = freightGroup ? freightGroup.FreightGroupName : "";
                        scope.displayValue = scope.freightGroupName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue, ""]);
                };

                scope.displayValue = scope.freightGroupKey;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("freightGroupName", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { freightGroupKey: "=", freightGroupName: "=", readOnly: "=", required: "=", controlName: "@", sapBrandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

